import React from 'react';
import { Eyebrow } from './ui/Eyebrow';
import { volumes } from '../data/content';
export function VolumesSection() {
  return <section id="volumenes" className="border-b border-line bg-cream" data-id="element-270" data-mp="3utm4aq96wfw5">
      <div className="mx-auto max-w-6xl px-5 py-20 lg:py-24" data-id="element-271" data-mp="cora4rvscz4a">
        <div className="max-w-2xl" data-id="element-272" data-mp="cm4yoh5rxzgs">
          <Eyebrow data-id="element-273" data-mp="7p6a0e4vqkpz">El sistema completo: 6 volúmenes</Eyebrow>
          <h2 className="mt-4 font-display text-3xl font-semibold leading-tight text-ink sm:text-4xl" data-id="element-274" data-mp="7nlb6cbj8fmb">
            Qué hay dentro de los seis volúmenes
          </h2>
          <p className="mt-5 text-[15px] leading-relaxed text-ink-soft" data-id="element-275" data-mp="3c57eu7eit9xg">
            Cada página es un PDF listo para imprimir, diseñado para enseñarse el mismo día — sin
            preparación, sin adaptaciones, sin adivinar.
          </p>
        </div>

        <ol className="mt-12 grid gap-6 md:grid-cols-2" data-id="element-276" data-mp="2xe87ezpf8rfg">
          {volumes.map(volume => <li key={volume.number} className="flex h-full flex-col rounded-2xl border border-line bg-paper p-7 shadow-card" data-id="element-277" data-mp="2sg6qolfgx475">
              <div className="flex items-baseline justify-between gap-4 border-b border-line pb-4" data-id="element-278" data-mp="29do2g3vrlmct">
                <span className="text-[11px] font-semibold uppercase tracking-eyebrow text-accent" data-id="element-279" data-mp="2ec8ql4xqsfkw">
                  Volumen {volume.number}
                </span>
                <span className="text-[11px] uppercase tracking-eyebrow text-ink-mute" data-id="element-280" data-mp="2o33himlxo3co">
                  {volume.pages}
                </span>
              </div>

              <h3 className="mt-5 font-display text-2xl font-semibold leading-tight text-ink" data-id="element-281" data-mp="1vf7j9dgpu3ds">
                {volume.title}
              </h3>
              <p className="mt-3 text-[15px] leading-relaxed text-ink-soft" data-id="element-282" data-mp="20d9689h9imuj">
                {volume.description}
              </p>

              <ul className="mt-auto flex flex-wrap gap-2 pt-6" data-id="element-283" data-mp="3btzfk1gzfusd">
                {volume.tags.map(tag => <li key={tag} className="rounded-full bg-sand px-3 py-1 text-xs font-medium text-ink-soft" data-id="element-284" data-mp="3fvavtgdyv3nw">
                    {tag}
                  </li>)}
              </ul>
            </li>)}
        </ol>
      </div>
    </section>;
}